import { IMailingRule, ISelectedEPS } from 'interfaces/MailingRule';
import { isValidDate, parseDateToPTBR } from 'utils/date';

const COMMANDS: { [upperCaseCommandName: string]: string } = {
  INACTIVATE: 'Inativada',
  ACTIVATION: 'Ativa',
};

const parseMailingRuleToList = (mailingRule: IMailingRule): IMailingRule => {
  const statusChanges = mailingRule.history
    .filter((h) => !!h.updatedFields.find((f) => f.path === '/status'))
    .map((h) => {
      const parsedDate = new Date(h.createdAt).toLocaleDateString();
      const isValidParsedDate = isValidDate(parsedDate);

      const parsedCommand = COMMANDS[h.historyAction];
      return `${parsedCommand} por ${h.user.name} ${
        isValidParsedDate ? 'em ' + parseDateToPTBR(parsedDate) : ''
      }`;
    });
  const collectRuleStrategies = mailingRule.collectRuleStrategies.map(
    (eps): ISelectedEPS => {
      let companyName;
      let epsId;
      if (typeof eps.epsId !== 'string' && eps.epsId !== null) {
        companyName = eps.epsId.fantasyName;
        epsId = eps.epsId._id;
      } else {
        companyName = 'Erro! Nenhuma EPS definida.';
        epsId = eps.epsId;
      }
      return {
        ...eps,
        companyName,
        epsId,
        id: epsId,
      };
    },
  );
  return Object.assign(
    {},
    {
      ...mailingRule,
      id: mailingRule._id,
      statusChanges,
      collectRuleStrategies,
    },
  );
};

export { parseMailingRuleToList };
